<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Listado de {{ title.plural }}
            </div>
    
            <div class="card-body-grid" *ngIf="result">
                <p-table #tableSearch autoLayout="true" [value]="result" [lazy]="true"
                    [lazyLoadOnInit]="false" [rowHover]="true"  [selectionMode]="'none'"
                    dataKey="Id"
                    [paginator]="false" [columns]="cols" sortOrder="0" 
                    [totalRecords]="result?.length" [loading]="loading"
                    [ngClass]="displayGridHidden(result)"
                    styleClass="table table-responsive-sm table-striped table-sm">
    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th nowrap scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}"
                                [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
    
                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [ngClass]="{ 'td-xs': col.reduce }">
                                
                                <span *ngIf="col.field !=='Link' && col.field !== 'FechaInspeccion' && col.field !== 'FechaCaducidad' && col.field !== 'FechaBorrado' && col.field !== 'Observaciones'">{{ rowData[col.field] }}</span>
                                <span *ngIf="col.field === 'FechaInspeccion' || col.field === 'FechaCaducidad' || col.field === 'FechaBorrado'">{{ rowData[col.field] | date:'dd/MM/yyyy HH:mm' }}</span>
                                <span *ngIf="col.field === 'Observaciones'" class="d-inline-block text-truncate titulo">
                                    {{ rowData[col.field] }}
                                </span>

                                <ng-container *ngIf="col.field === 'Link'" class="btn-group">                                    
                                    <ng-container *ngIf="hasViewAccess(rowData)">
                                        <button (click)="onView(rowData)" type="button" class="btn btn-sm btn-info" title="Consultar {{ title.singular }}">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="canBeDeleted(rowData, rowIndex)">
                                        <button (click)="onDelete(rowData)" type="button" class="btn btn-sm btn-danger" title="Eliminar {{ title.singular }} de U.I.">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="esInspeccionBorrada(rowData)">
                                        <button type="button" class="btn btn-sm" disabled title="Inspección eliminada">
                                            <span class="fa fa-archive"></span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
                    
                <div class="card-body-detalle">
                    <div *ngIf="!readonly && tableSearch?.totalRecords > 0" class="row">
                        <div class="nota-info col-4 me-2 unset-height">
                            <label class="col-form-label"><span class="fa fa-archive me-1"></span>Este icono indica que la inspección ha sido eliminada</label>
                        </div>
                        <div class="nota-info col-4 unset-height">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> <label class="col-form-label">Solo se permite eliminar la última inspección</label>
                        </div>
                    </div>
                    <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                    <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                </div>
            </div>
    
        </div>
    </div>
</div>

